import { Typography, Box } from "@mui/material";
import { HolidayVillage } from "@mui/icons-material";
import { TextContent, formatArea, getBoilerShare, truncateBySymbols } from "./ApartmentsHelpers";

export const BoilerContent = ({ item }) => {
    const boilerResources = item.BoilerResourceCount ?? "-";
    const ownerResources = item.OwnerResourceCount ?? "-";
    const displayTitle = truncateBySymbols(`Котёл ${item.boilerName}`, 44);
    const displayAddress = truncateBySymbols(item.address, 86);
    return (
        <TextContent>
            <Typography variant="h2" mb={2}>
                <Box display="flex" alignItems="center">
                    <HolidayVillage
                        color="primary"
                        fontSize="medium"
                        sx={{ mr: 1, mt: '-2px' }}
                    />
                    {displayTitle}
                </Box>
            </Typography>
            <Typography mb={2}>
                {displayAddress}
            </Typography>
            <Typography>
                Владею {ownerResources} из {boilerResources} апартаментов
            </Typography>
            <Typography>
                Площадь котла: {formatArea(item.BoilerArea)} м²
            </Typography>
            <Typography>
                Моя общая площадь: {formatArea(item.OwnerArea)} м²
            </Typography>
            <Typography>
                Моя доля в котле: {getBoilerShare(item.OwnerArea, item.BoilerArea)}%
            </Typography>
        </TextContent>
    );
};
